import { render } from "./NewPagination.vue?vue&type=template&id=223e3c1d&scoped=true"
import script from "./NewPagination.vue?vue&type=script&lang=js"
export * from "./NewPagination.vue?vue&type=script&lang=js"

import "./NewPagination.vue?vue&type=style&index=0&id=223e3c1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223e3c1d"]])

export default __exports__